var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgL2Trambd = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#E9EEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_735_3072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2082 28.5054C35.665 26.961 33.5237 26.3068 30.7737 27.0438L20.9676 17.2277L21.0972 16.7376C21.662 14.6185 21.0517 12.3407 19.5051 10.794C17.9303 9.21801 15.6916 8.63975 13.5743 9.22135C13.2724 9.30426 13.0373 9.54151 12.9574 9.84426C12.8774 10.147 12.9651 10.4688 13.1864 10.6902L15.5475 13.0514C16.2378 13.7434 16.2311 14.8516 15.5492 15.5353C14.8728 16.2136 13.7357 16.2125 13.0619 15.537L10.7003 13.1752C10.4789 12.9537 10.1562 12.8668 9.85341 12.9472C9.55059 13.0276 9.31423 13.2632 9.23161 13.5654C8.6585 15.6595 9.22229 17.9121 10.8046 19.4944C12.3472 21.0381 14.4858 21.6947 17.2374 20.9561L27.0443 30.7722C26.3124 33.5214 26.9437 35.6419 28.5077 37.2059C30.0844 38.7838 32.3242 39.3578 34.4369 38.7781C34.7389 38.6952 34.974 38.4579 35.054 38.1552C35.134 37.8524 35.0464 37.5306 34.8249 37.3091L32.4643 34.9485C31.774 34.2565 31.7808 33.1481 32.4626 32.4646C33.1475 31.7832 34.2821 31.794 34.9499 32.4637L37.3117 34.8248C37.5332 35.0463 37.8559 35.1332 38.1586 35.0527C38.4613 34.9723 38.6977 34.7368 38.7803 34.4346C39.3534 32.3409 38.7898 30.0877 37.2082 28.5054Z",
    fill: "url(#paint0_linear_735_3072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4068 24.6201L10.0284 32.9996C8.65721 34.3708 8.65721 36.6005 10.0284 37.9716C11.3995 39.3427 13.6292 39.3427 15.0003 37.9716L23.3786 29.5923L18.4068 24.6201ZM14.1746 35.244C13.8313 35.5873 13.2752 35.5873 12.9319 35.244C12.5886 34.9007 12.5886 34.3445 12.9319 34.0012L18.2627 28.6694C18.606 28.3261 19.1623 28.3261 19.5055 28.6694C19.8488 29.0127 19.8488 29.5688 19.5055 29.9121L14.1746 35.244Z",
    fill: "url(#paint1_linear_735_3072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7422 10.7726L37.227 9.25747C36.9419 8.97229 36.4993 8.9178 36.1535 9.12517L31.4925 11.9214C31.0021 12.2156 30.9188 12.8922 31.3231 13.2966L31.6941 13.6675L25.7773 19.5601L28.2638 22.0465L34.1806 16.1539L34.7032 16.6766C35.1075 17.0808 35.7842 16.9976 36.0783 16.5072L38.8746 11.8463C39.0819 11.5004 39.0274 11.0578 38.7422 10.7726Z",
    fill: "url(#paint2_linear_735_3072)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_735_3072",
    x1: 9.013,
    y1: 21.7496,
    x2: 38.999,
    y2: 21.7496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_735_3072",
    x1: 9,
    y1: 30.7315,
    x2: 23.3786,
    y2: 30.7315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_735_3072",
    x1: 25.7773,
    y1: 14.5448,
    x2: 38.9997,
    y2: 14.5448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_735_3072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(9 9)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgL2Trambd, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/L2trambd.cee2cc54.svg";
export { ForwardRef as ReactComponent };